import { $_TYPE, $_WC } from '@/confs/common.const.js';

export default {
    /*
     * 해당 자료번호 데이터 검색
     * 삭제 여부 검색 : searchActivityYn=1
     * max데이터 목록 : searchMaxBaseColumn=col1&searchMaxBaseColumn=col2
     * 일치 검색 : where=col::val
     * 불일치 검색 : whereNot=col::val
     * LIKE 검색 : whereLike=col::val
     * 시작 LIKE : whereStartLike=col::val
     * 끝 LIKE : whereEndLike=col::val
     * 정렬: orderBy=col::asc(desc)
     * 위경도: inIncludeDistance baseLttdVal baseLgtdVal
     * 리미트: searchLimit=val
     * 현재 시간 포함 검색: searchRangeFromVal=[컬럼명]&searchRangeToVal=[컬럼명]
     *   ex> searchRangeFromVal=basdtVal&searchRangeToVal=basdtVal2
     *     > 기준일1 <= 현재시간 <= 기준일2 인 데이터 조회
     */
    fetchRepoDataList(dataKdSqno, q, isIncludeFile) {
        let url = $_WC.apiBaseURL + "/repos/" + dataKdSqno + "/data";
        let queryStr = q;
        if(isIncludeFile) {
            if(typeof queryStr !== $_TYPE.UNDEF && queryStr.trim() !== '') {
                queryStr += "&";
            }
            queryStr += "isIncludeFile=true";
        }

        if(typeof queryStr !== $_TYPE.UNDEF && queryStr !== '') {
            url += "?" + queryStr;
        }
        return axios.get(url);
    },

    fetchRepoDataListWithCodeName(dataKdSqno, q, isIncludeFile) {
        let url = $_WC.apiBaseURL + "/repos/" + dataKdSqno + "/dataWithCodeName";
        let queryStr = q;
        if(isIncludeFile) {
            if(typeof queryStr !== $_TYPE.UNDEF && queryStr.trim() !== '') {
                queryStr += "&";
            }

            if(isIncludeFile) {
                queryStr += "isIncludeFile=true";
            }
        }

        if(typeof queryStr !== $_TYPE.UNDEF && queryStr !== '') {
            url += "?" + queryStr;
        }


        return axios.get(url);
    },

    fetchCacheRepoDataListWithCodeName(dataKdSqno, q) {
        let url = $_WC.apiBaseURL + "/repos/cache/" + dataKdSqno + "/dataWithCodeName";
        if(typeof q !== $_TYPE.UNDEF && q !== '') {
            url += "?" + q;
        }
        return axios.get(url);
    },

    // 해당 자료 번호의 데이터
    fetchRepoData(dataKdSqno, amnDataSqno, isIncludeFile) {
        let url = $_WC.apiBaseURL + "/repos/" + dataKdSqno + "/data/" + amnDataSqno;
        if(isIncludeFile) {
            url += "?isIncludeFile=true";
        }

        return axios.get(url);
    },
    // 해당 자료번호 중 기준일이 가장 최근인 데이터
    fetchMaxBasdtValDataList(dataKdSqno, isIncludeFile) {
        let q = "searchMaxBaseColumns=basdtVal";
        return this.fetchRepoDataList(dataKdSqno, q, isIncludeFile);
    },


    /*
     * maxCol : max값을 조회할 컬럼 명 (기준일 : basdt_val, 나머지: val1, val2, val3 ...)
     */
    fetchMaxDataListWithCodeName(dataKdSqno, maxCol = "", q = "", isIncludeFile) {
        if(q === '') {
            q = "?listKeyCol=" + maxCol;
        } else {
            q = "?listKeyCol=" + maxCol + "&" + q;
        }
        let url = $_WC.apiBaseURL + "/repos/" + dataKdSqno + "/maxDataWithCodeName" + q;

        return axios.get(url);
    },

    // 하위데이터 검색
    fetchLowsDataList(dataKdSqno, tableColnm, sqnoColnm, basColnm, q1) {
        var q = "tableColnm="+tableColnm + "&sqnoColnm=" + sqnoColnm + "&basColnm=" + basColnm + ((q1)?'&'+q1:'');
        return axios.get($_WC.apiBaseURL + '/repos/' + dataKdSqno + '/subData?' + q);
    },
    // 해당 코드 그룹의 코드 목록 가져오기
    fetchCodeListByCodeGroup(codeGroup) {
        return axios.get($_WC.apiBaseURL + '/code/' + codeGroup);
    },
    // 자료종류 번호로 자료종류 정보 및 데이터 가져오기
    fetchIncludeMetaDataBySqnos(dataKdSqnos, mngTblSqno) {
        let q = "isIncludeFile=true&mngTblSqno=" + mngTblSqno;
        for(let i = 0; i < dataKdSqnos.length; i++) {
            q += "&dataKdSqno=" + dataKdSqnos[i];
        }
        return axios.get($_WC.apiBaseURL + '/repos/includeMetaDataBySqnos?' + q);
    },
    // 뉴스 목록
    fetchNewsDataList(dataKdSqno, rflbDataSqno) {
        return axios.get($_WC.apiBaseURL + '/news/' + dataKdSqno + '/' + rflbDataSqno);
    },
    // 해당 그룹 코드의 자료 종류 정보 목록
    fetchRepoListByCodeGroup(codeGroup, paramKey) {
        let key = paramKey || 'lclasCd';
        let url = $_WC.apiBaseURL + "/repos?" + key + "=" + codeGroup;
        return axios.get(url);
    },

    // 해당 그룹 코드의 자료 종류 정보 목록
    fetchRepoListByCodeGroupQuery(q) {
        let url = $_WC.apiBaseURL + "/repos?" + q;
        return axios.get(url);
    },

    // 행정동 정보
    fetchSubAddongList(kostatAddongCd) {
        let url = $_WC.apiBaseURL + '/adareas/' + kostatAddongCd +"/subadareas";
        return axios.get(url);
    },
    // 여론동향 뉴스
    fetchNewsList(menuSqno, q) {
        let url = $_WC.apiBaseURL + '/news/menuorkd/front/' + menuSqno;
        if(typeof q !== 'undefined') {
            url = url + "?" + q;
        }
        return axios.get(url);
    },
    // 카운트 검색
    fetchListCountGroupByDataKdSqno(dataKdSqno, q) {
        return axios.get($_WC.apiBaseURL + '/repos/listCountGroupByDataKdSqno/' + dataKdSqno + '?' + q);
    },

    fetchListGroupCountByColArray(dataKdSqno, q) {
        return axios.get($_WC.apiBaseURL + '/repos/listGroupCountByColArray/' + dataKdSqno + '?' + q);
    },

    // 페이징 리스트
    fetchPageReposDataList(dataKdSqno, params) {
        let q = "";
        for(let key in params) {
            if(q != "") {
                q += "&";
            }
            if(Array.isArray(params[key])) {
                params[key].forEach(v => {
                    if(q != "") {
                        q += "&";
                    }
                    q += key + "=" + v;
                });
            } else {
                q += key + "=" + params[key];
            }
        }
        return axios.get($_WC.apiBaseURL + '/repos/pageRepos/' + dataKdSqno + '?' + q);
    },

    // 항목명 포함 데이터 검색
    fetchDataKdHdngList(dataKdSqno) {
        return axios.get($_WC.apiBaseURL + '/repos/dataKdHdngs/' + dataKdSqno);
    },

    // 지표데이터 검색
    fetchReposByDataIdxList(q) {
        if(typeof q !== 'undefined' && q != '') {
            q = "?" + q;
        } else {
            q = "";
        }
        return axios.get($_WC.apiBaseURL + '/repos/reposByDataIdxAjax' + q);
    },

    // 최신업데이트 지표데이터 검색
    fetchReposByDataLatestedIdxList(q) {
        if(typeof q !== 'undefined' && q != '') {
            q = "?" + q;
        } else {
            q = "";
        }
        return axios.get($_WC.apiBaseURL + '/repos/reposByDataLatestedIdxAjax' + q);
    },

    // 시설데이터 검색
    fetchReposByDataFacList(q) {
        if(typeof q !== 'undefined' && q != '') {
            q = "?" + q;
        } else {
            q = "";
        }
        return axios.get($_WC.apiBaseURL + '/repos/reposByDataFacAjax' + q);
    },

    // 조직도 - 직원정보
    fetchSsovUserList: function(q) {
        var url = $_WC.apiBaseURL + '/ssovUserList';
        if(typeof q !== 'undefined') {
            url = url + "?" + q;
        }
        return axios.get(url);
    },

    // 조직도 - 부서정보
    fetchSsovDeptList: function(q) {
        var url = $_WC.apiBaseURL + '/ssovDeptList';
        if(typeof q !== 'undefined') {
            url = url + "?" + q;
        }
        return axios.get(url);
    },

    // 데이터 소스 조회
    fetchDataSrcList(q) {
        if(typeof q !== 'undefined' && q != '') {
            q = "?" + q;
        } else {
            q = "";
        }
        return axios.get($_WC.apiBaseURL + '/dataSrcList' + q);
    },

    // openapi endpoint 조회
    fetchOpenapiEndpointList(q) {
        if(typeof q !== 'undefined' && q != '') {
            q = "?" + q;
        } else {
            q = "";
        }
        return axios.get($_WC.apiBaseURL + '/openapiEndpointList' + q);
    },

    stringToDate: function(val) {
        var baseDay = val || '';
        var dayStr = '';

        if(baseDay !== '') {
            baseDay = baseDay.replace(/-/gi, "");
            baseDay = baseDay.replace(/:/gi, "");
            baseDay = baseDay.replace(/ /gi, "");
        }

        if(baseDay.length >= 8) {
            var date = new Date();

            var y = baseDay.substring(0, 4);
            var m = baseDay.substring(4, 6);
            var d = baseDay.substring(6, 8);

            date.setFullYear(y);
            date.setMonth(m- 1, d);

            if(baseDay.length >= 10) {
                var h = baseDay.substring(8, 10);
                date.setHours(h);
            }

            if(baseDay.length >= 12) {
                var min = baseDay.substring(10, 12);
                date.setMinutes(min);
            }

            if(baseDay.length >= 14) {
                var sec = baseDay.substring(12, 14);
                date.setSeconds(sec);
            }

            return date;
        } else {
            return "";
        }


    },
    toDict: function(list, keyPropNm) {
        var dataMap = {};
        if(typeof list !== 'undefined' && list.length > 0) {
            list.forEach(function(data) {
                if(typeof data !== 'undefined' && typeof data[keyPropNm] !== 'undefined') {
                    dataMap[data[keyPropNm]] = data;
                }
            });
        }

        return dataMap;
    },
}
